import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ReturnPhysicalCopyPopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    trackingId: "",
    courierName: "",
    nftId: "",
    expectedDate: null,
    assetCondition: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDateChange = (date) => {
    setFormData({ ...formData, expectedDate: date });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg w-96 shadow-lg">
        <button className="float-right text-xl font-bold" onClick={onClose}>
          &times;
        </button>
        <h2 className="text-2xl font-bold mb-4 text-center">
          Return Physical Copy
        </h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="trackingId"
            value={formData.trackingId}
            onChange={handleChange}
            placeholder="Package Tracking ID"
            className="w-full px-3 py-2 mb-3 border rounded-lg"
            required
          />

          <input
            type="text"
            name="courierName"
            value={formData.courierName}
            onChange={handleChange}
            placeholder="Courier Service Name"
            className="w-full px-3 py-2 mb-3 border rounded-lg"
            required
          />

          <input
            type="text"
            name="nftId"
            value={formData.nftId}
            onChange={handleChange}
            placeholder="NFT ID"
            className="w-full px-3 py-2 mb-3 border rounded-lg"
            required
          />

          <div className="relative mb-3">
            <DatePicker
              selected={formData.expectedDate}
              onChange={handleDateChange}
              placeholderText="Expected Delivery Date"
              className="w-full px-3 py-2 border rounded-lg cursor-pointer"
              required
            />
          </div>

          <select
            name="assetCondition"
            value={formData.assetCondition}
            onChange={handleChange}
            className="w-full px-3 py-2 mb-4 border rounded-lg bg-white"
            required
          >
            <option value="">Condition of the Asset</option>
            <option value="New">New</option>
            <option value="Good">Good</option>
            <option value="Used">Used</option>
            <option value="Damaged">Damaged</option>
          </select>

          <button
            type="submit"
            className="w-full bg-yellow-400 text-black font-bold py-2 rounded-md"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReturnPhysicalCopyPopup;
